module.exports = {"notification.message":"Wix.com ใช้คุ้กกี้เพื่อให้คุณได้รับประสบการณ์ที่ดีที่สุด","notification.got.it":"เข้าใจละ","notification.more.info":"อ่านเพิ่มเติม","notification.got.it.arrow":"arrow icon"}


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_th.json
// module id = 59
// module chunks = 0